import "./Servicemetaverse.css";
import "../../machinelearning/MachineLearningCommon.css";
import Button from "../../machinelearning/button/Button";
import { Link, useNavigate } from "react-router-dom";

const Servicemetaverse = () => {
  return (
    <div id="service-metaverse" className="machinemainclass">
      <div className="sContainer">
        <div className="serviceContent">
          <h2>Ready to Scale Your Metaverse Vision?</h2>
          <p>
           Partner with a trusted metaverse development company to design, build, and scale immersive platforms with secure architecture, real-world use cases, and long-term growth.
          </p>
          <div>
            <Link to="/contact_us" className="link">
              <Button arrowColor="purple" text="Get Free Expert Consultation" />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Servicemetaverse;
